<ng-container [ngSwitch]="component?.componentConfig?.selector">
  <ng-container *ngSwitchCase="'cs-static--newsletter'">
    <ng-container #newsletter></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'cs-static--appointments'">
    <ng-container #appointments></ng-container>
  </ng-container>
</ng-container>
